import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { BACKGROUNDJOBS_MAIN } from 'constants/codigosTransacciones'

import MainPage from './main'

export default function BackgroundJobsPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${BACKGROUNDJOBS_MAIN}`} component={MainPage} />
      </Switch>
    </Suspense>
  )
}
